import { api, formatApiError } from "./api";

function parseFilenameFromDisposition(header) {
  if (!header) return null;
  const match = /filename="([^"]+)"/i.exec(header);
  return match?.[1] || null;
}

function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/**
 * Download a guest-list CSV from a host export endpoint.
 * @returns {{ rowCount: number | null, filename: string }}
 */
export async function downloadGuestListCsv({ url, params = {}, fallbackFilename = "guest-list.csv" }) {
  try {
    const response = await api.get(url, {
      params,
      responseType: "blob",
    });

    const filename =
      parseFilenameFromDisposition(response.headers["content-disposition"]) || fallbackFilename;
    const rowCountHeader = response.headers["x-export-row-count"];
    const rowCount = rowCountHeader != null ? Number(rowCountHeader) : null;

    triggerBlobDownload(response.data, filename);
    return { rowCount: Number.isFinite(rowCount) ? rowCount : null, filename };
  } catch (err) {
    if (err?.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text();
        const parsed = JSON.parse(text);
        const detail = parsed?.detail;
        if (typeof detail === "string") throw new Error(detail);
      } catch (parseErr) {
        if (parseErr instanceof Error && parseErr.message !== err.message) throw parseErr;
      }
    }
    throw new Error(formatApiError(err));
  }
}

export const EXPORT_RANGE_OPTIONS = [
  { value: "last_event", label: "Last event" },
  { value: "3_months", label: "Last 3 months" },
  { value: "1_year", label: "Last year" },
];

export function buildEventExportUrl(eventId) {
  return `/events/${eventId}/guest-list-export.csv`;
}

export function buildOrganizerExportUrl() {
  return "/organizers/me/guest-list-export.csv";
}
